import api from '../utils/api';
import { submitAndPollTextImprovement } from '../utils/pollTextImprovementJob';

export async function listInboundRouters({
  page = 1,
  perPage = 20,
  channelId,
  status,
} = {}) {
  const params = { page, per_page: perPage };
  if (channelId) {
    params.channel_id = channelId;
  }
  if (status) {
    params.status = status;
  }
  const { data } = await api.get('/inbound-routers/', { params });
  return data;
}

export async function getInboundRouter(id) {
  const { data } = await api.get(`/inbound-routers/${id}`);
  return data;
}

export async function getInboundRouterByExternalChannel(externalChannelId) {
  const { data } = await api.get(
    `/inbound-routers/by-external-channel/${encodeURIComponent(externalChannelId)}`
  );
  return data;
}

export async function createInboundRouter(payload) {
  const { data } = await api.post('/inbound-routers/', payload);
  return data;
}

export async function updateInboundRouter(id, payload) {
  const { data } = await api.put(`/inbound-routers/${id}`, payload);
  return data;
}

export async function deleteInboundRouter(id) {
  const { data } = await api.delete(`/inbound-routers/${id}`);
  return data;
}

export async function improveInboundRouterInstructions({
  text,
  routerName,
  agentRoutes,
  userConsiderations,
}) {
  return submitAndPollTextImprovement(() =>
    api.post('/inbound-routers/improve-instructions', {
      text,
      router_name: routerName || undefined,
      agent_routes: agentRoutes || [],
      user_considerations: userConsiderations || undefined,
    })
  );
}

export async function improveInboundRouteDescription({
  text,
  routeLabel,
  agentId,
  agentName,
  keywords,
  routerName,
  routerInstructions,
  otherRoutes,
  userConsiderations,
}) {
  return submitAndPollTextImprovement(() =>
    api.post('/inbound-routers/improve-route-description', {
      text: text || '',
      route_label: routeLabel,
      agent_id: agentId || undefined,
      agent_name: agentName || undefined,
      keywords: keywords || [],
      router_name: routerName || undefined,
      router_instructions: routerInstructions || undefined,
      other_routes: otherRoutes || [],
      user_considerations: userConsiderations || undefined,
    })
  );
}
